module.exports = __webpack_public_path__ + "img/jewelry.6ca4e888.png";